import React from 'react'
import {useStaticQuery, graphql} from 'gatsby'
import * as LoadingCSS from './css/loading.module.css'

const dataQuery = graphql`
  query {
    common: commonJson {
      buttons {
        loading
      }
    }
  }
`

export function Loading() {
  const {common} = useStaticQuery(dataQuery)

  return (
    <button className="btn btn-primary rounded-pill" type="button" disabled>
      <span
        className={`${LoadingCSS.spinner} spinner-border spinner-border-sm`}
        role="status"
        aria-hidden="true"></span>
      {` ${common.buttons.loading}`}
    </button>
  )
}
